export const lineCampaignTranslations = {
  // Header / gates
  back: "Back to LINE OA",
  connectTitle: "Connect LINE Messaging first",
  connectDesc: "You need to connect your LINE Messaging API before sending campaigns.",
  connectCta: "Go to LINE settings",
  title: "Campaigns",
  subtitle: "Filter your customers by what they did, then send a targeted LINE message.",

  // Step 1 — audience
  step1: "Choose your audience",
  seg_awaiting_payment: "Awaiting payment",
  seg_awaiting_payment_desc: "Placed an order but haven't paid yet",
  seg_abandoned_cart: "Abandoned cart",
  seg_abandoned_cart_desc: "Added items to cart but never checked out",
  seg_paid: "Paid customers",
  seg_paid_desc: "Completed at least one paid order",
  seg_all_customers: "All customers",
  seg_all_customers_desc: "Everyone who has ordered from your store",
  minOrders: "Min. total orders",
  minSpend: "Min. lifetime spend (฿)",
  any: "Any",
  refineLabel: "Refine by purchase history",
  optional: "(optional)",
  preview: "Preview recipients",
  loading: "Loading…",
  reachable: "reachable on LINE",
  withoutLine: "without LINE (can't message)",

  // Step 2 — recipients
  step2: "Select recipients",
  selectedCount: "{a} of {b} selected",
  noMatch: "No LINE-reachable customers match this segment right now.",
  colCustomer: "Customer",
  colOrders: "Orders",
  colSpend: "Spend",
  unpaidCount: "{n} unpaid",
  inCartLabel: "In cart:",
  inOrderLabel: "In order:",
  inCartCount: "In cart · {n}:",
  inOrderCount: "In order · {n}:",
  itemsTotal: "{n} items",
  moreItems: "+{n} more",
  newCustomer: "New · never purchased",
  noOrdersHint: "—",

  // Step 3 — compose
  step3: "Write your message",
  messagePlaceholder: "Type the message your customers will receive on LINE…",
  includeLinkTitle: "Include each customer's payment link",
  includeLinkDesc: "We append every customer's own order link so they can pay in one tap. Customers with no unpaid order are skipped.",
  previewLabel: "Preview",
  messagePreviewPlaceholder: "Your message will appear here…",
  sentTo: "Sent to {n} customers.",
  skippedNote: "{n} skipped (no unpaid order). ",
  failedNote: "{n} failed.",
  sendTo: "Send to {n} customers",
  sending: "Sending…",
  // Honest failure feedback (nothing sent)
  sendFailedTitle: "Not sent",
  sendFailedGeneric: "The message could not be sent.",
  allSkippedNote: "Nothing sent — all {n} recipients have no payment link (no unpaid order).",
  allFailedNote: "Nothing sent — all {n} recipients failed to send.",
  lineRejected: "LINE rejected the send: {reason}",

  // Sent history (past targeted sends — Delivered + status only)
  historyTitle: "Sent history",
  historyEmpty: "No sends yet.",
  historyColDate: "Date",
  historyColMessage: "Message",
  historyColDelivered: "Delivered",
  historyColStatus: "Status",
  historyPeople: "people",
  historyStatusSent: "Sent",
  historyStatusFailed: "Failed",

  // Expandable recipient list (who received a send + blocked status)
  recipientsLoading: "Loading recipients…",
  recipientsError: "Couldn't load recipients.",
  recipientsEmpty: "Recipients weren't recorded for this send.",
  recipientsTitle: "Recipients",
  recipientsBlocked: "Blocked",
  recipientsReached: "Reached",
  recipientsCappedNote: "Block status checked for the first {n} of {total}.",

  // Visit attribution (how many recipients visited the store after the send)
  visitsLoading: "Loading visits…",
  visitsLabel: "Visited",
  visitsUniqueSuffix: "unique",
  visitsOrders: "{n} orders",
  visitsUnavailable: "Visit tracking is unavailable right now.",
  visitsNone: "No tracked visits yet.",
  visitsNote: "Only sends that include a link are tracked, from this feature onward.",

  // Confirm dialog
  confirmTitle: "Send this campaign?",
  confirmBody: "This will send your message to {n} customers in the \"{segment}\" audience.",
  eachGetsLink: " Each will get their own payment link.",
  confirmUndo: " This can't be undone.",
  cancel: "Cancel",
  sendNow: "Send now",

  // --- Audience filter builder ---
  customersWho: "Customers who",
  connAnd: "and",
  connOr: "or",
  selectCollections: "Select collections",
  selectProducts: "Select products",
  nSelected: "{n} selected",
  search: "Search…",
  noMatches: "No matches.",
  addCondition: "Add condition",
  conditionsHelp: "Conditions apply top-to-bottom using each row's and / or.",
  removeCondition: "Remove condition",

  // condition types
  type_bought_collection: "Bought from collection",
  type_bought_product: "Bought product",
  type_not_bought_collection: "Didn't buy from collection",
  type_not_bought_product: "Didn't buy product",
  type_spend_on_collection: "Spent on collection ≥",
  type_spend_on_product: "Spent on product ≥",
  type_total_spend: "Lifetime spend ≥",
  type_qty_of_collection: "Units from collection ≥",
  type_qty_of_product: "Units of product ≥",
  type_order_count: "Total orders ≥",
  type_purchased_within: "Purchased within",
  type_not_purchased_within: "Not purchased in last",

  // condition groups
  group_purchased: "Purchased",
  group_didnt_buy: "Didn't buy",
  group_spend: "Spend",
  group_quantity: "Quantity",
  group_recency: "Recency",

  // numeric suffixes
  suffix_baht: "฿",
  suffix_units: "units",
  suffix_orders: "orders",
  suffix_days: "days",

  // message type (text / rich / video)
  typeText: "Text",
  typeRich: "Rich message",
  typeVideo: "Video",
  richHint: "An image that opens your link, with a title and a button",
  videoHint: "A video with a preview thumbnail",

  // coupon picker (attribution)
  couponLabel: "Coupon",
  couponOptional: "optional",
  couponNone: "No coupon",
  couponHint: "Ties this send to a coupon so you can see the exact orders it drove.",
  couponInsert: "Insert code into message",
  couponCodePrefix: "Code: ",
}
